<template>
	<div class="col-lg-8">
		<div class="activity-list ">
			<div class="activity-item text-block">
				<PagesApp :links="meta.links" class="pages" :click="getPage" />

				<div class="">
					<div>
						Пользователь имеет роль "Регистратор"
					</div>
					<div>
						<div class="col-xs-6 col-sm-4">
							<input type="radio" id="all" name="created" value="0" v-model="has_registrar_role"
								@change="changeFilter" />
							<label for="all">Неважно</label>
						</div>
						<div class="col-xs-6 col-sm-4">
							<input type="radio" id="reg" name="created" value="1" v-model="has_registrar_role"
								@change="changeFilter" />
							<label for="reg">Да</label>
						</div>
						<div class="col-xs-6 col-sm-4">
							<input type="radio" id="users" name="created" value="2" v-model="has_registrar_role"
								@change="changeFilter" />
							<label for="users">Нет</label>
						</div>
					</div>
				</div>

				<table class="table table-striped">
					<tr>
						<th v-for="field in fields" :key="field.key">{{ field.name }}</th>
					</tr>
					<tr v-for="item in data" :key="item.id">
						<td v-for="field in fields" :key="field.key">
							{{ item[field.key]?.name ?? item[field.key]?.full_name ?? item[field.key] }}
						</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import PagesApp from '@/components/PagesApp.vue'
import { getDataWithToken } from '@/api/getData'
import { getConfig } from '@/auth';

export default {
	components: {
		PagesApp
	},
	data() {
		return {
			data: [],
			fields: [
				{ "name": "Дата", "key": "datePrint" },
				{ "name": "ФИО", "key": "name" },
				{ "name": "Имя пользователя", "key": "username" },
				{ "name": "IP-адрес", "key": "ip" },
			],
			error: '',
			meta: {},
			links: {},
			per_page: 50,
			has_registrar_role: 0
		}
	},
	created() {
		let url = getConfig().journalEvents
		this.getPage(url + '?t=1')
	},
	methods: {
		changeFilter: function () {
			let url = getConfig().journalEvents
			this.getPage(url + '?t=1')
		},
		getPage: function (url) {
			let filter = this.has_registrar_role == 0
				? ''
				: this.has_registrar_role == 1
					? '&filter[context][has_registrar_role]=true'
					: '&filter[context][has_registrar_role]=false'

			getDataWithToken(`${url}&filter[context][event]=login-to-registrar-app&per_page=${this.per_page}${filter}`).then(x => {
				this.data = x.data.map(el => {
					let date = new Date(el.date)
					el.datePrint = date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
					el.name = el.context.name
					el.username = el.context.username
					el.ip = el.context.ip

					return el
				})

				this.meta = x.meta
				this.links = x.links
			})
				.catch(error => {
					this.error = error + ''
				})
		}
	}
}
</script>